
import DataTable from 'primevue/datatable'

export default {
  components: {
    DataTable    
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
    items: {
      type: Array,
      default: () => []
    },
    sortOrder: {
      type: Number,
      default: 0
    },
    sortField: {
      type: String,
      default: undefined
    },
    skip: {
      type: Number,
      default: 0
    },
    overrideSkip: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: true
    }
  },
  emits: ['page', 'sort', 'row-dblclick'],
  data: function() {
    return {
      first: this.skip,
      rows: 20,
    }
  },

  computed: {
    empty() {
      return !this.items.length
    },
    max_items() {
      return this.items.length === this.total 
    }
  },

  watch: {
    '$route.fullPath'() {
      this.configureTable()
    },
    // when items change (while sorting) paginator switches to first and ignores skip value
    // its a library bug, need to prevent it
    'items': {
      handler: function () {
        this.first = this.overrideSkip ? new Number(this.skip) : undefined
      },
      deep: true
    },
    async empty() {
      if (!this.empty) {
        await this.$nextTick()
        this.configureTable()
      }
    },
    rows(next, prev){
      if (!this.max_items && next > prev) {
        this.$emit('page', {first: 0, rows: this.rows})
      }
    }
  },
  mounted() {
    this.configureTable()
  },
  methods: {
    configureTable() {
      const row = this.$el.querySelector('.bodyRow')
      if (this.empty || !row) return

      const paginator = this.$el.querySelector('.paginator-root')
      const row_rect = row.getBoundingClientRect()
      let h_in = window.innerHeight - row_rect.top - row_rect.height      
      if (paginator) {
        h_in = h_in - paginator.offsetHeight + row_rect.height 
      }
      const rows = Math.floor(h_in / row_rect.height) 
      this.rows = Math.max(rows, 1)
    }
  },
}
